/*
Kids
*/
import violet from "../assets/violet.png"
import dash from "../assets/dash.png"
import pumba from "../assets/pumba.png"
import simba from "../assets/simba.png"
import babyyoda from "../assets/babyyoda.png"
import dory from "../assets/dory.png"
/*
Starwars
*/
import drth from "../assets/darthvader.png"
import bb8 from "../assets/bb-8.png"
import c3po from "../assets/c3po.png"
import kylo from "../assets/kyloren.png"
import r2d2 from "../assets/r2d2.png"
/*
Simspsons
*/
import homer from "../assets/homer.png"
import marge from "../assets/marge.png"
import maggie from "../assets/maggie.png"
import bart from "../assets/bart.png"
import lisa from "../assets/lisa.png"
/*
Avengers
*/
import groot from "../assets/groot.png"
import tchalla from "../assets/blackpanther.png"
import bruce from "../assets/bruce.png"
import peter from "../assets/peter.png"
import tony from "../assets/tony.png"
/*
Lion King & Mulan
*/
import nala from "../assets/nala.png"
import rafiki from "../assets/rafiki.png"
import scar from "../assets/scar.png"
import mushu from "../assets/mushu.png"
import mulan from "../assets/mulan.png"

const avatars = {
    kids: {dory:dory, violet:violet, dash:dash, pumba:pumba, simba:simba, babyyoda:babyyoda},
    simpsons: {homer:homer, maggie:maggie, marge:marge, bart:bart, lisa:lisa},
    starWars: {drth:drth, bb8:bb8, kylo:kylo, c3po:c3po,r2d2:r2d2},
    avengers: {tony:tony, peter:peter, tchalla:tchalla,groot:groot,bruce:bruce},
    lionKing: {scar:scar, nala:nala, rafiki:rafiki, mulan:mulan, mushu:mushu},
}

export default avatars;